import Component from './Component';

export default class SubMenu extends Component {
    load() {
        this.initNavigateOnChange();

        super.load();
    }

    initNavigateOnChange() {
        $(".banner__subnav__select-new").on('change', function (e) {
            window.location = $(this).val();
        });

        $(".subcategoryNavigation").on('change', function (e) {
          window.location = $(this).val();
      });
    }
}
